function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9735 16C31.2784 16 33.9574 18.6353 33.9574 21.8856C33.9574 25.1367 31.2784 27.7721 27.9735 27.7721C24.6686 27.7721 21.9896 25.1367 21.9896 21.8856C21.9896 18.6345 24.6694 16 27.9735 16ZM27.9735 16C31.2784 16 33.9574 18.6353 33.9574 21.8856C33.9574 25.1367 31.2784 27.7721 27.9735 27.7721C24.6686 27.7721 21.9896 25.1367 21.9896 21.8856C21.9896 18.6345 24.6694 16 27.9735 16ZM25.7296 29.1895H30.7172C34.9865 29.1895 38.4468 32.5927 38.4468 36.7923V37.282C38.4468 38.937 34.9856 39 30.7172 39H25.7296C21.4603 39 18 38.9975 18 37.282V36.7923C18 32.5927 21.4603 29.1895 25.7296 29.1895Z",
  fill: "white"
});

function SvgCoinIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconUser);
export default __webpack_public_path__ + "static/media/CoinIconUSER.e3296515.svg";
export { ForwardRef as ReactComponent };